import React, { Fragment } from "react";
import PropTypes from "prop-types";
// import { isNil } from "ramda";
// import IconArrow from "assets/img/flecha-hacia-abajo.svg";
// import ReactHtmlParser from "react-html-parser";
// import { getImage } from "application/functions";
import logoZara from "assets/img/logo_zara.png";

function Header(props) {
  // const { structure, size } = props;
  // const isScrollable = size === "xs_vertical" || size === "sm_vertical";

  // const getSuggestionParser = (suggestBack) => {
  //   const { host, protocol } = window.location;
  //   if (
  //     suggestBack.includes("openshift.axinocp1.central.inditex.grp") ||
  //     suggestBack.includes("pre-openshift.axpreocp1.central.inditex.grp")
  //   ) {
  //     const regex = new RegExp("(https?://.*?)/");
  //     const strRegex = regex.exec(suggestBack);
  //     if (strRegex && strRegex.length > 0) {
  //       const value = strRegex[1];
  //       const suggestion = `${suggestBack.replace(
  //         value,
  //         `${protocol}//${host}`
  //       )}`;
  //       const suggestionParsed = ReactHtmlParser(suggestion);
  //       return <>{suggestionParsed}</>;
  //     }
  //   }
  //   return <>{ReactHtmlParser(suggestBack)}</>;
  // };

  return (
    <Fragment>
      <div className="header__container-img">
        {/* <div
          className="background-image-novertical"
          style={{
            backgroundImage: `url(${getImage(
              size,
              structure
            )})`,
          }}
        > */}
        <img alt="logo" style={{ width: "45%" }} src={logoZara} />
      </div>
    </Fragment>
  );
}

Header.propTypes = {
  structure: PropTypes.object,
  height: PropTypes.bool,
};

export default Header;
